"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var divStyle = {
    border: '5px solid pink',
    position: 'fixed',
    bottom: 0,
    right: 0,
    padding: '10px 15px',
    borderRadius: '20px 0 0 2px',
    borderStyle: 'solid',
    borderWidth: '1px 0 0 1px',
    cursor: 'help',
    zIndex: 999999999999,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    textAlign: 'left',
    maxHeight: '100%',
    overflow: 'auto'
};
var experimentGroup = {
    borderBottom: 'solid 1px black',
    paddingTop: '15px'
};
var radioWidthOverride = {
    width: '1em',
    clip: 'inherit',
    height: '1em',
    position: 'inherit'
};
var Debugger = /** @class */ (function (_super) {
    __extends(Debugger, _super);
    function Debugger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showExperiments: true
        };
        /* eslint-disable react/destructuring-assignment */
        _this.updateBucket = function (experimentName, bucketName, experimentState) {
            var _a;
            var updateExperiment = _this.props.updateExperiment;
            var newState = __assign(__assign({}, experimentState), (_a = {}, _a[experimentName] = __assign(__assign({}, experimentState[experimentName]), { assignedBucket: bucketName }), _a));
            updateExperiment(experimentName, newState);
        };
        _this.showHideExperiments = function () {
            _this.setState(function (state) { return ({
                showExperiments: !state.showExperiments
            }); });
        };
        _this.updateState = function (state) { return _this.setState(state); };
        return _this;
    }
    Debugger.prototype.render = function () {
        var _this = this;
        var _a = this.props, environment = _a.environment, experiments = _a.experiments;
        var showExperiments = this.state.showExperiments;
        return environment === 'production' ? null : (react_1.default.createElement("div", { style: divStyle },
            react_1.default.createElement("button", { type: "button", style: { textAlign: 'center' }, onClick: function () { return _this.showHideExperiments(); } }, "Experiments"),
            showExperiments && (react_1.default.createElement(react_1.default.Fragment, null, Object.keys(experiments).map(function (experimentName) { return (react_1.default.createElement("div", { key: experimentName, style: experimentGroup },
                react_1.default.createElement("b", null, experimentName),
                (experiments[experimentName].buckets || []).sort().map(function (bucket) {
                    var bucketKey = experimentName + "-" + bucket;
                    return (react_1.default.createElement("div", { key: bucketKey },
                        react_1.default.createElement("label", { htmlFor: bucketKey },
                            react_1.default.createElement("input", { style: radioWidthOverride, type: "radio", name: bucketKey, id: bucketKey, value: bucket, onChange: function () {
                                    return _this.updateBucket(experimentName, bucket, experiments);
                                }, checked: bucket ===
                                    experiments[experimentName].assignedBucket }),
                            bucket)));
                }))); })))));
    };
    Debugger.defaultProps = {
        experiments: {},
        updateExperiment: function () { }
    };
    return Debugger;
}(react_1.PureComponent));
exports.default = Debugger;
